import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const items = [
    "सत्यमेव जयते",
    "Civil Services Mentorship",
    "NavSankalpIAS",
    "एक संकल्प · एक भारत",
    "Himanshu Bhansali Sir",
  ];

  return (
    <section
      data-testid="editorial-marquee"
      className="border-y border-ink-15 bg-cream-dim py-8 md:py-10 overflow-hidden"
      aria-label="Editorial motto marquee"
    >
      <Marquee gradient={false} speed={38} pauseOnHover>
        {items.concat(items).map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-item text-4xl md:text-6xl lg:text-7xl text-ink px-10">
              {t}
            </span>
            <span className="text-saffron text-3xl">✦</span>
            <span className="px-6" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
